/* ZERO ORAL — zero-homepage.js */
(function () {
  'use strict';

  /* ── Nav: add scrolled class ── */
  var nav = document.getElementById('zo-nav');
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('zo-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile menu ── */
  var menuOpen = false;
  window.zoToggleMenu = function () {
    menuOpen = !menuOpen;
    var mob = document.getElementById('zo-mob');
    var ham = document.getElementById('zo-ham');
    var spans = ham ? ham.querySelectorAll('span') : [];
    if (mob) {
      mob.classList.toggle('zo-open', menuOpen);
      mob.setAttribute('aria-hidden', String(!menuOpen));
    }
    if (ham) ham.setAttribute('aria-expanded', String(menuOpen));
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    if (spans.length === 3) {
      if (menuOpen) {
        spans[0].style.transform = 'translateY(6px) rotate(45deg)';
        spans[1].style.opacity   = '0';
        spans[2].style.transform = 'translateY(-6px) rotate(-45deg)';
      } else {
        spans[0].style.transform = spans[2].style.transform = '';
        spans[1].style.opacity   = '1';
      }
    }
  };
  window.zoCloseMenu = function () { if (menuOpen) zoToggleMenu(); };

  /* ── Footer email ── */
  window.zoFootSubmit = function () {
    var inp = document.getElementById('zo-foot-email');
    if (!inp) return;
    var v = (inp.value || '').trim();
    if (!v || !v.includes('@')) {
      inp.style.borderBottom = '1px solid rgba(184,144,106,.7)';
      setTimeout(function () { inp.style.borderBottom = ''; }, 1600);
      return;
    }
    inp.value       = '';
    inp.placeholder = "You're on the list.";
  };
  var fe = document.getElementById('zo-foot-email');
  if (fe) fe.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') zoFootSubmit();
  });

  /* ── Smooth scroll for all anchor links ── */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = this.getAttribute('href');
      var target = id && id.length > 1 && document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Subtle hero parallax (desktop only) ── */
  if (window.matchMedia('(min-width: 769px)').matches) {
    var heroImg = document.querySelector('.zo-hero__media img');
    if (heroImg) {
      window.addEventListener('scroll', function () {
        var sy = window.scrollY;
        if (sy < window.innerHeight) {
          heroImg.style.transform = 'translateY(' + (sy * 0.28) + 'px)';
        }
      }, { passive: true });
    }
  }

})();
